import React from 'react';

import { PolicyDocumentsForm } from '../../update/components/privacyPolicy/PolicyDocumentsForm';
import { ErrorMessageBox } from '../common/ErrorMessageBox';

const PrivacyPolicyView = ({ errorMessage, ...formProps }) => (
    <div className="loginActionsColumn">
        <div className="loginActions privacyPolicy">
            <PolicyDocumentsForm
                {...formProps}
                error={errorMessage ? <ErrorMessageBox errorMessage={errorMessage} /> : null}
            />
        </div>
    </div>
);

export default PrivacyPolicyView;
